export default __webpack_public_path__ + "static/media/arrow-down.faecb2f2.svg";